import React, { useState } from "react";
import MediaCmsLeftBarMenu from "./MediaCmsLeftBarMenu";
import Header from "../../components/Header/Header";
import { useSearchParams } from "react-router-dom";

function News() {
  const [searchParams] = useSearchParams();
  const [isApp] = useState(searchParams?.get("app") || 0);
  return (
    <>
      {/* Header */}
      {!isApp ?
      <Header
        mobileHeaderOptions={{
          menuIcon: false,
          wishlistIcon: false,
          darveysLargeTextIcon: false,
          searchIcon: false,
          shoppingBagIcon: true,
          backButtonIcon: true,
          pageHeadingShow: true,
          pageHeadingText: "Press and events",
          darveysSmallIcon: false,
          userAccountIcon: false,
        }}
      />
      :
      ""
      }

      {/* <div className="spacer-grey"></div> */}

      <div className="clearfix"></div>

      <section className="about-page">
        <div className="container-fluid">
          <div className="row">
            <MediaCmsLeftBarMenu activeMenu="news" />
            <div className="col-xl-10 col-lg-9 col-12">
              <div className="about-img inner-banner mt-50 mt-sm-0">
                <img
                  src="../assets/images/media/media-banner.jpg"
                  className="img-fluid mx-auto d-block"
                  alt=""
                />
              </div>
              <div className="row mt-80">
                <div className="col-md-4">
                  <div className="media-box">
                    <div className="media-img">
                      <a
                        href="../assets/images/media/news-item-1.jpg"
                        target={"_blank"}
                      >
                        <img
                          src="../assets/images/media/news-item-1.jpg"
                          className="img-fluid mx-auto d-block"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="media-text">
                      <div className="date">6-March-2018</div>
                      <div className="media-heading mt-20">
                        <a
                          href="../assets/images/media/news-item-1.jpg"
                          target={"_blank"}
                        >
                          My Picks - ET Panache (Page No-2)
                        </a>
                      </div>
                      <p className="mt-20">
                        Information About Darveys.Com Director.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="media-box">
                    <div className="media-img">
                      <a
                        href="../assets/images/media/news-item-2.jpg"
                        target={"_blank"}
                      >
                        <img
                          src="../assets/images/media/news-item-2.jpg"
                          className="img-fluid mx-auto d-block"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="media-text">
                      <div className="date">28-February-2019</div>
                      <div className="media-heading mt-20">
                        <a
                          href="../assets/images/media/news-item-2.jpg"
                          target={"_blank"}
                        >
                          Light Touch - ET Panache (Page No-2)
                        </a>
                      </div>
                      <p className="mt-20">
                        Diesel destroyed denim buster jeans Available at
                        Darveys.com.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="media-box">
                    <div className="media-img">
                      <a
                        href="../assets/images/media/news-item-3.jpg"
                        target={"_blank"}
                      >
                        <img
                          src="../assets/images/media/news-item-3.jpg"
                          className="img-fluid mx-auto d-block"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="media-text">
                      <div className="date">17-February-2019</div>
                      <div className="media-heading mt-20">
                        <a
                          href="../assets/images/media/news-item-3.jpg"
                          target={"_blank"}
                        >
                          Times Of India (Page No-15)
                        </a>
                      </div>
                      <p className="mt-20">
                        Get Discounted Global Luxe Products Sitting In India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-80">
                <div className="col-md-4">
                  <div className="media-box">
                    <div className="media-img">
                      <a
                        href="../assets/images/media/news-item-4.jpg"
                        target={"_blank"}
                      >
                        <img
                          src="../assets/images/media/news-item-4.jpg"
                          className="img-fluid mx-auto d-block"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="media-text">
                      <div className="date">1-February-2019</div>
                      <div className="media-heading mt-20">
                        <a
                          href="../assets/images/media/news-item-4.jpg"
                          target={"_blank"}
                        >
                          The Morning Standard - leisure - Shoes (Page No-2)
                        </a>
                      </div>
                      <p className="mt-20">
                        Branded Attraction -Checkout Darveys.com's latest
                        collection from the brands like Burberry, Armani, Coach,
                        Versace, Jimmy Choo, Hugo Boss, Bulgari and many more
                        available on the website.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="media-box">
                    <div className="media-img">
                      <a
                        href="../assets/images/media/news-item-5.jpg"
                        target={"_blank"}
                      >
                        <img
                          src="../assets/images/media/news-item-5.jpg"
                          className="img-fluid mx-auto d-block"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="media-text">
                      <div className="date">21-January-2019</div>
                      <div className="media-heading mt-20">
                        <a
                          href="../assets/images/media/news-item-5.jpg"
                          target={"_blank"}
                        >
                          The Morning Standard - leisure - Shoes (Page No-2)
                        </a>
                      </div>
                      <p className="mt-20">
                        One Stop Shop: Darveys.com is India's largest platform
                        to buy authentic luxury brands at upto 60% Off with
                        currently 20,000 plus items live on the website.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="media-box">
                    <div className="media-img">
                      <a
                        href="../assets/images/media/news-item-6.jpg"
                        target={"_blank"}
                      >
                        <img
                          src="../assets/images/media/news-item-6.jpg"
                          className="img-fluid mx-auto d-block"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="media-text">
                      <div className="date">20-January-2019</div>
                      <div className="media-heading mt-20">
                        <a
                          href="../assets/images/media/news-item-6.jpg"
                          target={"_blank"}
                        >
                          The Sunday Standard - leisure - Shoes (Page No-2)
                        </a>
                      </div>
                      <p className="mt-20">
                        One Stop Shop: Darveys.com is India's largest platform
                        to buy authentic luxury watches at upto 60% Off.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="clearfix"></div>
    </>
  );
}

export default News;
